import promotionCodeSymbols from "../symbols/promotionCodes";
export interface IPromotionCodeState {
  loading: boolean;
  error: boolean;
  message: string;
}
const initialState: IPromotionCodeState = {
  loading: false,
  error: false,
  message: ''
};

export default function CreatePromotionCodesSymbolsReducer(
  state = initialState,
  action: any
) {
  switch (action.type) {
    case promotionCodeSymbols.CREATE_PROMOTION_CODES:
      return { ...state, loading: true, error: false, message: '' };
    case promotionCodeSymbols.CREATE_PROMOTION_CODE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        message: ''
      };
    case promotionCodeSymbols.CREATE_PROMOTION_CODES_FAILURE:
      return {
        loading: false,
        error: true,
        message: action.payload
      };
    case promotionCodeSymbols.PROMOTION_CODES_CLEAR_ERROR:
      return {
        ...state,
        error: false,
        message: ''
      };
    default:
      return state;
  }
}
